module.exports = "<div class=\"filter_item_collapsible\"><div class=\"lpview_listitem_collapsible lp_collapsible_icon\"></div></div>";